import themeTuuleliinid from './theme-tuuleliinid.json'
import themeKihnu from './theme-kihnu.json'
import themeSark from './theme-sark.json'
import themeTrial from './theme-trial.json'
import { BoraTheme } from '@/root/shared-types'

type Config = {
  defaultLocale: string
  theme: string
  companyForm?: boolean
  /** False when the client's own website is the entry point: no homepage, `/select-date-sail` opens today's sails. */
  hasHomepage?: boolean
  oldBoraOrigin?: string
  privatePersonForm?: boolean
  /** Customer Support phone shown in ticket texts */
  supportPhone?: string
}

const configs: Record<string, Config> = {
  [themeTuuleliinid.theme]: themeTuuleliinid,
  [themeKihnu.theme]: themeKihnu,
  [themeSark.theme]: themeSark,
  [themeTrial.theme]: themeTrial,
}

export const currentConfig = configs[process.env.NEXT_PUBLIC_THEME as BoraTheme]
export const getCurrentConfig = (theme: BoraTheme) => configs[theme]
